import {Controller} from "@hotwired/stimulus";
import axios from 'axios';
import {deburr} from "lodash";

export default class extends Controller {
    static targets = ['filtersForm', 'facetFilter', 'facetListItem'];

    async showAllFacetOptions(event) {
        event.preventDefault();
        if (!window.Turbo) {
            return;
        }
        const response = await axios.get(`/search/facet/${event.target.dataset.facet}?${event.target.dataset.query}`);
        Turbo.renderStreamMessage(response.data);

        $('#facetsSeeMore').modal();
    }

    selectFacetValue(event) {
        event.preventDefault();

        const { machineName, value, facetOptionName } = event.currentTarget.dataset;
        // eslint-disable-next-line no-useless-escape
        const facetCheckbox = this.filtersFormTarget.querySelector(`input[name="${machineName}[]"][value=\'${value}\']`);
        if (facetCheckbox) {
            facetCheckbox.click();
        } else {
            const newFacetCheckbox = this.filtersFormTarget.querySelector(`input[name="${machineName}[]"]`).cloneNode();
            newFacetCheckbox.value = value;
            newFacetCheckbox.className = 'd-none';
            newFacetCheckbox.id = '';
            const newFacetCheckboxInDOM = this.filtersFormTarget.appendChild(newFacetCheckbox);

            setTimeout(() => {
                newFacetCheckboxInDOM.click();
            }, 0);
        }

        $('#facetsSeeMore').modal('toggle');
    }

    filterFacets(event) {
        event.preventDefault();

        const facetFilter = deburr(this.facetFilterTarget.value.toLowerCase());

        this.facetListItemTargets.forEach((facetListItem) => {
            const facetListItemNormalizedValue = deburr(facetListItem.dataset.value.toLowerCase());
            if (!facetListItemNormalizedValue.includes(facetFilter)) {
                facetListItem.classList.remove('d-flex');
                facetListItem.classList.add('d-none');
            } else {
                facetListItem.classList.remove('d-none');
                facetListItem.classList.add('d-flex');
            }
        });
    }
}
